<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="菜单名称" prop="name">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <a-form-model-item label="编码" prop="code">
      <a-input
        v-model="form.data.code"/>
    </a-form-model-item>
    <a-form-model-item label="上层菜单" prop="parentId">
      <a-cascader
        :props="{ checkStrictly: true }"
        v-model="form.data.parentId"
        :options="menu.tree"/>
    </a-form-model-item>
    <a-form-model-item label="类别" prop="type">
      <a-radio v-model="form.data.type" label="MENU">菜单</a-radio>
      <a-radio v-model="form.data.type" label="BUTTON">按钮</a-radio>
    </a-form-model-item>
    <a-form-model-item label="菜单图标" prop="icon" v-if="form.data.type==='MENU'">
      <a-input v-model="form.data.icon"/>
    </a-form-model-item>
    <a-form-model-item label="前端路径" prop="path" v-if="form.data.type==='MENU'">
      <a-input
        v-model="form.data.path"/>
    </a-form-model-item>
    <a-form-model-item label="请求接口" prop="path">
      <a-input
        v-model="form.data.interfaceApi"/>
    </a-form-model-item>
    <a-form-model-item label="请求方式" prop="path">
      <a-select v-model="form.data.requestMethod" placeholder="请选择请求方式">
        <a-select-option
          v-for="item in options"
          :key="item"
          :label="item"
          :value="item">
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item>
      <a-button type="primary" v-if="!menuId" @click="onAdd">创建</a-button>
      <a-button type="primary" v-if="menuId" @click="onUpdate">更新</a-button>
      <a-button @click="onCancel">取消</a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _addMenu,
  _queryMenu,
  _queryMenus,
  _updateMenu,
} from '@/api/sysMenuApi';

function treeGenerator(x, data, ignoreId) {
  const children = data
    .filter(child => child.value !== ignoreId && child.parentId === x.value)
    .map(child => treeGenerator(child, data));
  return {
    ...x,
    children,
  };
}

function getTreeNodeParent(x, data) {
  if (!x) {
    return [];
  }
  const parent = data.filter(child => child.value === x);
  if (parent[0]) {
    return [...getTreeNodeParent(parent[0].parentId, data), x];
  }
  return [x];
}

async function getMenus() {
  const result = await _queryMenus({});
  if (result.code === 1200) {
    const menus = result.data.menus.filter(x => x.type === 'MENU').map(x => ({
      value: x.id,
      label: x.name,
      parentId: x.parentId,
    }));
    this.menu.data = menus;
    this.menu.tree = [
      {
        value: null,
        label: '根节点',
        children: menus
          .filter(x => !x.parentId && x.value !== this.menuId)
          .map(x => treeGenerator(x, menus, this.menuId)),
      },
    ];
  }
}

async function getMenu() {
  const result = await _queryMenu(this.menuId);
  if (result.code === 1200) {
    this.form.data.name = result.data.menu.name;
    this.form.data.icon = result.data.menu.icon;
    this.form.data.path = result.data.menu.path;
    this.form.data.type = result.data.menu.type;
    this.form.data.code = result.data.menu.code;
    this.form.data.interfaceApi = result.data.menu.interfaceApi;
    this.form.data.requestMethod = result.data.menu.requestMethod;
    this.form.data.parentId = [null, ...getTreeNodeParent(
      result.data.menu.parentId,
      this.menu.data,
    )];
  }
}

async function onAdd() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addMenu({
        name: this.form.data.name,
        icon: this.form.data.icon,
        code: this.form.data.code,
        path: this.form.data.path,
        type: this.form.data.type,
        interfaceApi:this.form.data.interfaceApi ,
        requestMethod:this.form.data.requestMethod ,
        parentId: this.form.data.parentId.length > 0
          ? this.form.data.parentId[this.form.data.parentId.length - 1] : null,
      });
      if (result.code === 1200) {
        if (this.onSubmitHandler) {
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.onSubmitHandler();
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

async function onUpdate() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateMenu(this.menuId, {
        name: this.form.data.name,
        icon: this.form.data.icon,
        code: this.form.data.code,
        path: this.form.data.path,
        type: this.form.data.type,
        interfaceApi:this.form.data.interfaceApi ,
        requestMethod:this.form.data.requestMethod ,
        parentId: this.form.data.parentId.length > 0
          ? this.form.data.parentId[this.form.data.parentId.length - 1] : null,
      });
      if (result.code === 1200) {
        if (this.onSubmitHandler) {
          this.$message({
            message: '更新成功',
            type: 'success',
          });
          if (this.onSubmitHandler) {
            this.onSubmitHandler();
          }
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'MenuEdit',
  props: {
    menuId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    menuId(val) {
      this.form.data = {
        name: '',
        parentId: [null],
        icon: '',
        path: '',
        type: 'MENU',
        interfaceApi: '',
        requestMethod: '',
      };
      this.getMenus();
      if (val) {
        this.getMenu();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getMenu,
    getMenus,
  },
  data() {
    return {
      options: ['GET','POST','PUT','DELETE','PATCH'],
      menu: {
        data: [],
        tree: [],
      },
      form: {
        data: {
          name: '',
          type: 'MENU',
          icon: '',
          code: '',
          path: '',
          parentId: [null],
          interfaceApi: '',
          requestMethod: '',
        },
        rules: {
          name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
          parentId: [{ required: false, message: 'please choose parentId', trigger: 'blur' }],
        },
        disabled: false,
        title: '',
      },
    };
  },
  created() {
    this.getMenus();
    if (this.menuId) {
      this.getMenu();
    }
  },
};
</script>
